import { render, staticRenderFns } from "./StatusBox.vue?vue&type=template&id=62315239&scoped=true&lang=pug&"
import script from "./StatusBox.vue?vue&type=script&lang=coffee&"
export * from "./StatusBox.vue?vue&type=script&lang=coffee&"
import style0 from "./StatusBox.vue?vue&type=style&index=0&id=62315239&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62315239",
  null
  
)

export default component.exports